import {CSSProperties, useState} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";

import type {ILeadModalConsultant} from "../../../application/types/lead/ILeadModalConsultant";

interface IProps {
    consultant: ILeadModalConsultant;
    className?: string;
    style?: CSSProperties;
}

export const ForYouBannerConsultantAvatar = ({consultant, className, style}: IProps) => {
    const [hasImageError, setHasImageError] = useState(false);
    const imageSrc = consultant.image?.s216 || consultant.image?.s144 || consultant.image?.s72;

    return (
        <div className={cx(consultantAvatarStyle, className)} style={style}>
            {!imageSrc || hasImageError ? (
                <span className={consultantAvatarFallbackStyle} aria-label={consultant.fullName}>
                    {getConsultantInitials(consultant.fullName)}
                </span>
            ) : (
                <Image
                    src={imageSrc}
                    src2x={consultant.image.s216}
                    alt={consultant.fullName}
                    width="216"
                    height="216"
                    loading="lazy"
                    onError={() => setHasImageError(true)}
                    imageClassName={consultantAvatarImageStyle}
                />
            )}
        </div>
    );
};

function getConsultantInitials(fullName: string) {
    return fullName
        .split(" ")
        .map((namePart) => namePart[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
}

const consultantAvatarStyle = css({
    width: "9.6rem",
    height: "9.6rem",
    border: "0.5rem solid var(--colors-primary)",
    backgroundColor: "var(--colors-primary)",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: "var(--shadow-1)",

    md: {
        width: "12rem",
        height: "12rem",
        borderWidth: "0.5rem"
    }
});

const consultantAvatarImageStyle = css({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block"
});

const consultantAvatarFallbackStyle = css({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-primary)",
    fontWeight: 700,
    fontSize: "2rem"
});
import {CSSProperties, useState} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";

import type {ILeadModalConsultant} from "../../../application/types/lead/ILeadModalConsultant";

interface IProps {
    consultant: ILeadModalConsultant;
    className?: string;
    style?: CSSProperties;
}

export const ForYouBannerConsultantAvatar = ({consultant, className, style}: IProps) => {
    const [hasImageError, setHasImageError] = useState(false);
    const imageSrc = consultant.image?.s216 || consultant.image?.s144 || consultant.image?.s72;

    return (
        <div className={cx(consultantAvatarStyle, className)} style={style}>
            {!imageSrc || hasImageError ? (
                <span className={consultantAvatarFallbackStyle} aria-label={consultant.fullName}>
                    {getConsultantInitials(consultant.fullName)}
                </span>
            ) : (
                <Image
                    src={imageSrc}
                    src2x={consultant.image.s216}
                    alt={consultant.fullName}
                    width="216"
                    height="216"
                    loading="lazy"
                    onError={() => setHasImageError(true)}
                    imageClassName={consultantAvatarImageStyle}
                />
            )}
        </div>
    );
};

function getConsultantInitials(fullName: string) {
    return fullName
        .split(" ")
        .map((namePart) => namePart[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
}

const consultantAvatarStyle = css({
    width: "9.6rem",
    height: "9.6rem",
    border: "0.5rem solid var(--colors-primary)",
    backgroundColor: "var(--colors-primary)",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: "var(--shadow-1)",

    md: {
        width: "12rem",
        height: "12rem",
        borderWidth: "0.5rem"
    }
});

const consultantAvatarImageStyle = css({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block"
});

const consultantAvatarFallbackStyle = css({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-primary)",
    fontWeight: 700,
    fontSize: "2rem"
});
